// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1xMFs","label":"Section_label__1qnYZ","contentWrap":"Section_contentWrap__3HdjG","footer":"Section_footer__Ocx7f","footerInner":"Section_footerInner__16c5E"};